import * as SC from './DefaultContainerStyles'

export default SC.DefaultContainer
